import Vue from 'vue';
import VueRouter from 'vue-router';
import extend from 'lodash/extend';
import AppBase from '../app-base';
import { loader as loadComponents } from '../components';

class BasePage {

    /**
     * Construct the class
     */
    constructor() {
        this.registerComponents();
    }

    /**
     * Object of components to automatically pull in
     *
     * @returns {Object}
     */
    getComponents() {
        return {};
    }

    /**
     * Register any page-specific components
     */
    registerComponents() {
        loadComponents(this.getComponents());
    }

    /**
     * Enable this page to act as an SPA
     *
     * @param config
     */
    enableRouter(config) {
        this.hasRouter = true;
        Vue.use(VueRouter);

        if ($('body').hasClass('error-403')) {
            config.routes = [];
        }

        const router = new VueRouter({
            mode: 'history',
            scrollBehavior() {
                return {
                    x: 0,
                    y: 0,
                }
            },
            ...config,
        });

        this.vue = new Vue(extend(AppBase, {
            router,
        }));
    }

}

export default BasePage;
